import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import IndexView from '@/views/IndexView'
import JottingView from '@/views/JottingView'
import ArticleView from '@/views/ArticleView'
import TechnologyView from '@/views/TechnologyView'
import AboutmeView from '@/views/AboutmeView'

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'DefaultView',
      component: IndexView
    },
    {
      path: '/index.html',
      name: 'IndexView',
      component: IndexView
    },
    {
      path: '/jotting.html',
      name: 'JottingView',
      component: JottingView
    },
    {
      path: '/article.html',
      name: 'ArticleView',
      component: ArticleView
    },
    {
      path: '/technology.html',
      name: 'TechnologyView',
      component: TechnologyView
    },
    {
      path: '/aboutme.html',
      name: 'AboutmeView',
      component: AboutmeView
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js